"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styles_1 = require("./styles");
exports.MessagePopup = (props) => {
    function renderFooter() {
        var _a;
        if (!props.footer) {
            return (react_1.default.createElement("div", { className: 'text-center' },
                react_1.default.createElement(styles_1.ModalMessageLink, { onClick: props.onClose, type: "link", "data-dismiss": "modal", title: (_a = props.closeButtonTitle) !== null && _a !== void 0 ? _a : "Fechar" })));
        }
        else
            return props.footer;
    }
    return (react_1.default.createElement("div", { className: "modal-dialog" },
        react_1.default.createElement(styles_1.ModalMessage, { className: "modal-content text-center" },
            react_1.default.createElement(styles_1.ModalMessageHeader, null, props.header),
            react_1.default.createElement(styles_1.ModalMessageBody, null, props.children),
            renderFooter())));
};
